// import React, { useEffect, useState } from "react";
// import api from "../../../api/axios";
// import Swal from "sweetalert2";

// export default function ReimbursementManagement() {
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [usingSample, setUsingSample] = useState(false);
//   const [showForm, setShowForm] = useState(false);

//   const [reimbursements, setReimbursements] = useState([]);
//   const [employees, setEmployees] = useState([]);

//   const [form, setForm] = useState({
//     employee_id: "",
//     claimed_on: "",
//     category: "",
//     description: "",
//     amount: "",
//     meta: {},
//   });

//   useEffect(() => {
//     loadEmployees();
//     loadData();
//   }, []);

//   /* ============================
//         LOAD EMPLOYEES
//   ============================ */
//   const loadEmployees = async () => {
//     try {
//       const res = await api.get("hrms/employees");
//       setEmployees(res.data.data);
//     } catch (e) {
//       console.warn("Employee API failed → sample employees used");

//       setEmployees([
//         { id: 1, first_name: "Alice", last_name: "Johnson" },
//         { id: 2, first_name: "Eve", last_name: "Davis" },
//         { id: 3, first_name: "Frank", last_name: "White" },
//         { id: 4, first_name: "Grace", last_name: "Lee" },
//       ]);
//     }
//   };

//   /* ============================
//         LOAD REIMBURSEMENTS
//   ============================ */
//   const loadData = async () => {
//     setLoading(true);

//     try {
//       const res = await api.get("hrms/prms/reimbursements");
//       setReimbursements(res.data.data.data);
//       setUsingSample(false);
//     } catch (e) {
//       console.warn("Reimbursement API failed → using sample data");

//       const sample = [
//         {
//           id: 1,
//           employee: { first_name: "Alice", last_name: "Johnson" },
//           claimed_on: "2023-10-25",
//           description: "Client meeting travel",
//           status: "approved",
//           amount: 1500,
//         },
//         {
//           id: 2,
//           employee: { first_name: "Eve", last_name: "Davis" },
//           claimed_on: "2023-10-28",
//           description: "Software subscription",
//           status: "pending",
//           amount: 490,
//         },
//         {
//           id: 3,
//           employee: { first_name: "Frank", last_name: "White" },
//           claimed_on: "2023-11-02",
//           description: "Office supplies",
//           status: "pending",
//           amount: 750,
//         },
//         {
//           id: 4,
//           employee: { first_name: "Grace", last_name: "Lee" },
//           claimed_on: "2023-10-15",
//           description: "Team lunch",
//           status: "rejected",
//           amount: 2200,
//         },
//       ];

//       setReimbursements(sample);
//       setUsingSample(true);
//     }

//     setLoading(false);
//   };

//   /* ============================
//          HANDLE FORM CHANGE
//   ============================ */
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   /* ============================
//          SAVE REIMBURSEMENT
//   ============================ */
//   const saveRequest = async () => {
//     setSaving(true);

//     const payload = {
//       employee_id: form.employee_id,
//       amount: Number(form.amount),
//       category: form.category,
//       claimed_on: form.claimed_on,
//       description: form.description,
//       status: "pending",
//       meta: {},
//     };

//     try {
//       await api.post("hrms/prms/reimbursements", payload);

//       Swal.fire({
//         title: "Success!",
//         text: "Reimbursement added successfully.",
//         icon: "success",
//         timer: 1500,
//         showConfirmButton: false,
//       });

//       setShowForm(false);
//       setForm({
//         employee_id: "",
//         claimed_on: "",
//         description: "",
//         amount: "",
//         meta: {},
//       });

//       await loadData();
//     } catch (e) {
//       console.warn("API unavailable → saving sample only");

//       Swal.fire({
//         title: "Sample Mode",
//         text: "Saved locally (API not ready).",
//         icon: "warning",
//       });

//       const emp = employees.find((x) => x.id == form.employee_id);

//       const newItem = {
//         id: reimbursements.length + 1,
//         employee: emp,
//         claimed_on: form.claimed_on,
//         description: form.description,
//         status: "pending",
//         amount: Number(form.amount),
//       };

//       setReimbursements([...reimbursements, newItem]);
//       setShowForm(false);
//     }

//     setSaving(false);
//   };

//   if (loading) return <div className="text-center p-5 fw-bold">Loading...</div>;

//   return (
//     <div style={{ background: "#eef6fd", minHeight: "100vh" }}>
//       <div className="container py-4">
//         {/* HEADER */}
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h3 className="fw-bold">Reimbursement Management</h3>

//           <button className="btn btn-primary" onClick={() => setShowForm(true)}>
//             <i className="bi bi-plus-circle me-2"></i> Add Request
//           </button>
//         </div>

//         {usingSample && (
//           <span className="badge bg-warning text-dark mb-3">
//             Using Sample Data
//           </span>
//         )}

//         {/* ============================
//               ADD FORM
//         ============================ */}
//         {showForm && (
//           <div className="bg-white border rounded shadow-sm p-4 mb-4">
//             <h5 className="fw-bold mb-3">Add Reimbursement Request</h5>

//             <div className="row g-3">
//               <div className="col-md-6">
//                 <label className="form-label fw-semibold">Employee</label>

//                 <select
//                   name="employee_id"
//                   className="form-select"
//                   value={form.employee_id}
//                   onChange={handleChange}
//                 >
//                   <option value="">Select Employee</option>

//                   {employees.map((emp) => (
//                     <option key={emp.id} value={emp.id}>
//                       {emp.first_name} {emp.last_name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="col-md-6">
//                 <label className="form-label fw-semibold">Date</label>
//                 <input
//                   type="date"
//                   name="claimed_on"
//                   className="form-control"
//                   value={form.claimed_on}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="col-md-6">
//                 <label className="form-label fw-semibold">Description</label>
//                 <input
//                   name="description"
//                   className="form-control"
//                   placeholder="Enter description"
//                   value={form.description}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="col-md-6">
//                 <label className="form-label fw-semibold">Category</label>
//                 <input
//                   name="category"
//                   className="form-control"
//                   placeholder="Category"
//                   value={form.category}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="col-md-6">
//                 <label className="form-label fw-semibold">Amount (INR)</label>
//                 <input
//                   type="number"
//                   name="amount"
//                   className="form-control"
//                   value={form.amount}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="mt-4 d-flex justify-content-end gap-2">
//               <button
//                 className="btn btn-secondary"
//                 onClick={() => setShowForm(false)}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="btn btn-primary"
//                 onClick={saveRequest}
//                 disabled={saving}
//               >
//                 {saving ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm me-2"></span>
//                     Saving...
//                   </>
//                 ) : (
//                   "Save Request"
//                 )}
//               </button>
//             </div>
//           </div>
//         )}

//         {/* ============================
//               TABLE LIST
//         ============================ */}
//         <div className="bg-white border rounded shadow-sm p-4">
//           <h5 className="fw-bold mb-4">Employee Reimbursements</h5>

//           <div className="table-responsive">
//             <table className="table align-middle">
//               <thead>
//                 <tr>
//                   <th>Employee</th>
//                   <th>Date</th>
//                   <th>Description</th>
//                   <th>Category</th>
//                   <th>Status</th>
//                   <th>Amount</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {reimbursements.map((item) => (
//                   <tr key={item.id}>
//                     <td>
//                       {item.employee?.first_name} {item.employee?.last_name}
//                     </td>
//                     <td>
//                       {new Date(item.claimed_on).toISOString().split("T")[0]}
//                     </td>
//                     <td>{item.description}</td>
//                     <td>{item.category}</td>
//                     <td>
//                       <StatusBadge status={item.status} />
//                     </td>
//                     <td>{item.amount} INR</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ============================
//         STATUS BADGES
// ============================ */
// function StatusBadge({ status }) {
//   const s = status?.toLowerCase();

//   if (s === "approved")
//     return (
//       <span className="badge rounded-pill bg-success-subtle text-success px-3 py-2">
//         Approved
//       </span>
//     );

//   if (s === "pending")
//     return (
//       <span className="badge rounded-pill bg-warning-subtle text-warning px-3 py-2">
//         Pending
//       </span>
//     );

//   if (s === "rejected")
//     return (
//       <span className="badge rounded-pill bg-danger-subtle text-danger px-3 py-2">
//         Rejected
//       </span>
//     );

//   return status;
// }

import React, { useEffect, useState } from "react";
import api from "../../../api/axios";
import Swal from "sweetalert2";

export default function ReimbursementManagement() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [usingSample, setUsingSample] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [reimbursements, setReimbursements] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [form, setForm] = useState({
    employee_id: "",
    claimed_on: "",
    category: "",
    description: "",
    amount: "",
    meta: {},
  });

  useEffect(() => {
    loadEmployees();
    loadData();
  }, []);

  /* ============================
        LOAD EMPLOYEES
  ============================ */
  const loadEmployees = async () => {
    try {
      const res = await api.get("hrms/employees");
      setEmployees(res.data.data);
    } catch (e) {
      console.warn("Employee API failed → using sample employees");

      setEmployees([
        { id: 1, first_name: "Alice", last_name: "Johnson" },
        { id: 2, first_name: "Eve", last_name: "Davis" },
        { id: 3, first_name: "Frank", last_name: "White" },
        { id: 4, first_name: "Grace", last_name: "Lee" },
      ]);
    }
  };

  /* ============================
       LOAD REIMBURSEMENTS
  ============================ */
  const loadData = async () => {
    setLoading(true);

    try {
      const res = await api.get("hrms/prms/reimbursements");
      setReimbursements(res.data.data.data);
      setUsingSample(false);
    } catch (e) {
      console.warn("Reimbursement API failed → sample mode");

      const sample = [
        {
          id: 1,
          employee: { first_name: "Alice", last_name: "Johnson" },
          claimed_on: "2023-10-25",
          description: "Client meeting travel",
          category: "Travel",
          status: "approved",
          amount: 1500,
        },
        {
          id: 2,
          employee: { first_name: "Eve", last_name: "Davis" },
          claimed_on: "2023-10-28",
          description: "Software subscription",
          category: "Software",
          status: "pending",
          amount: 490,
        },
      ];

      setReimbursements(sample);
      setUsingSample(true);
    }

    setLoading(false);
  };

  /* ============================
         FORM CHANGE
  ============================ */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ============================
        SAVE (NO FULL RELOAD)
  ============================ */
  const saveRequest = async () => {
    setSaving(true);

    const payload = {
      employee_id: form.employee_id,
      amount: Number(form.amount),
      category: form.category,
      claimed_on: form.claimed_on,
      description: form.description,
      status: "pending",
      meta: {},
    };

    try {
      const res = await api.post("hrms/prms/reimbursements", payload);

      const emp = employees.find((e) => e.id == form.employee_id);

      const newItem = {
        id: res.data?.data?.id || Date.now(),
        employee: emp,
        claimed_on: form.claimed_on,
        description: form.description,
        category: form.category,
        status: "pending",
        amount: Number(form.amount),
      };

      // DIRECTLY UPDATE LIST (NO RELOAD)
      setReimbursements((prev) => [newItem, ...prev]);

      Swal.fire({
        title: "Success!",
        text: "Reimbursement added successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      setShowForm(false);

      // reset form
      setForm({
        employee_id: "",
        claimed_on: "",
        category: "",
        description: "",
        amount: "",
        meta: {},
      });
    } catch (e) {
      console.warn("API unavailable → sample save");

      Swal.fire({
        title: "Sample Mode",
        text: "Saved locally (API not ready).",
        icon: "warning",
      });

      const emp = employees.find((x) => x.id == form.employee_id);

      const newItem = {
        id: Date.now(),
        employee: emp,
        claimed_on: form.claimed_on,
        category: form.category,
        description: form.description,
        status: "pending",
        amount: Number(form.amount),
      };

      // Update UI instantly
      setReimbursements((prev) => [newItem, ...prev]);

      setShowForm(false);
    }

    setSaving(false);
  };

  if (loading) return <div className="text-center p-5 fw-bold">Loading...</div>;

  return (
    <div style={{ background: "#eef6fd", minHeight: "100vh" }}>
      <div className="container py-4">
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="fw-bold">Reimbursement Management</h3>

          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            <i className="bi bi-plus-circle me-2"></i> Add Request
          </button>
        </div>

        {usingSample && (
          <span className="badge bg-warning text-dark mb-3">
            Using Sample Data
          </span>
        )}

        {/* ============================
              ADD FORM
        ============================ */}
        {showForm && (
          <div className="bg-white border rounded shadow-sm p-4 mb-4">
            <h5 className="fw-bold mb-3">Add Reimbursement Request</h5>

            <div className="row g-3">
              {/* EMPLOYEE */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Employee</label>

                <select
                  name="employee_id"
                  className="form-select"
                  value={form.employee_id}
                  onChange={handleChange}
                >
                  <option value="">Select Employee</option>

                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.first_name} {emp.last_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* DATE */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Date</label>
                <input
                  type="date"
                  name="claimed_on"
                  className="form-control"
                  value={form.claimed_on}
                  onChange={handleChange}
                />
              </div>

              {/* DESC */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Description</label>
                <input
                  name="description"
                  className="form-control"
                  placeholder="Enter description"
                  value={form.description}
                  onChange={handleChange}
                />
              </div>

              {/* CATEGORY */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Category</label>
                <input
                  name="category"
                  className="form-control"
                  placeholder="Category"
                  value={form.category}
                  onChange={handleChange}
                />
              </div>

              {/* AMOUNT */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Amount (INR)</label>
                <input
                  type="number"
                  name="amount"
                  className="form-control"
                  value={form.amount}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* ACTION BUTTONS */}
            <div className="mt-4 d-flex justify-content-end gap-2">
              <button
                className="btn btn-secondary"
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>

              <button
                className="btn btn-primary"
                onClick={saveRequest}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving...
                  </>
                ) : (
                  "Save Request"
                )}
              </button>
            </div>
          </div>
        )}

        {/* ============================
              TABLE LIST
        ============================ */}
        <div className="bg-white border rounded shadow-sm p-4">
          <h5 className="fw-bold mb-4">Employee Reimbursements</h5>

          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Category</th>
                  <th>Status</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {reimbursements.map((item) => (
                  <tr key={item.id}>
                    <td>
                      {item.employee?.first_name} {item.employee?.last_name}
                    </td>
                    <td>
                      {new Date(item.claimed_on).toISOString().split("T")[0]}
                    </td>
                    <td>{item.description}</td>
                    <td>{item.category}</td>
                    <td>
                      <StatusBadge status={item.status} />
                    </td>
                    <td>{item.amount} INR</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ============================
        STATUS BADGES
============================ */
function StatusBadge({ status }) {
  const s = status?.toLowerCase();

  if (s === "approved")
    return (
      <span className="badge rounded-pill bg-success-subtle text-success px-3 py-2">
        Approved
      </span>
    );

  if (s === "pending")
    return (
      <span className="badge rounded-pill bg-warning-subtle text-warning px-3 py-2">
        Pending
      </span>
    );

  if (s === "rejected")
    return (
      <span className="badge rounded-pill bg-danger-subtle text-danger px-3 py-2">
        Rejected
      </span>
    );

  return status;
}
